<template>
  <div>
    <div class="is-size-6 mb-2 has-text-weight-bold">
      Pricing Summary
    </div>
    <pricing-summary 
      :estimation="estimation" 
      :pricing-type="pricingType"
      :overflow="false"/>

    <!-- <hr v-if="estimationHasWall || estimationHasRailing || estimationHasCladding"/>
    
    <div class="mb-5" v-if="estimationHasWall">
      <div class="is-size-6 mb-2 has-text-weight-bold">
        Solar Wall Detailed Pricing
      </div>
      <detailed-pricing-wall 
        :estimation="estimation" 
        :has-mpa-price="pricingType == 'mpa'"
        :has-dpa-price="pricingType == 'dpa'"
        :is-fullwidth="true"
        :has-footnotes="false"/>
    </div>

    <div class="mb-5" v-if="estimationHasRailing">
      <div class="is-size-6 mb-2 has-text-weight-bold">
        SolaRail Detailed Pricing
      </div>
      <detailed-pricing-railing 
        :estimation="estimation" 
        :has-mpa-price="pricingType == 'mpa'"
        :has-dpa-price="pricingType == 'dpa'"
        :is-fullwidth="true"
        :has-footnotes="false"/>
    </div>
  
    <div class="mb-5" v-if="estimationHasCladding">
      <div class="is-size-6 mb-2 has-text-weight-bold">
        Cladding Detailed Pricing
      </div>
      <detailed-pricing-cladding 
        :estimation="estimation"
        :is-fullwidth="true"
        :has-footnotes="false"/>
    </div> -->

    <template v-if="estimationHasWall || estimationHasRailing">
      <hr/>
    
      <div class="columns">
        <div class="column" v-if="estimationHasWall">
          <div class="is-size-6 mb-2 has-text-weight-bold">
            Solar Wall Financial Flow
          </div>
          <value-solar-wall 
            :estimation="estimation"
            :pricing-type="pricingType"/>
        </div>

        <div class="column" v-if="estimationHasRailing">
          <div class="is-size-6 mb-2 has-text-weight-bold">
            Solar Railing Financial Flow
          </div>
          <value-solar-railing 
            :estimation="estimation"
            :pricing-type="pricingType"/>
        </div>
      </div>
    </template>

    <template v-if="(estimationHasWall || estimationHasRailing) && hasTaxIncentives">
      <hr/>

      <div v-if="estimationHasWall">
        <div class="is-size-6 mb-2 has-text-weight-bold">
          Solar Cladding Cost Breakdown (Total and per SQFT)
        </div>
        <tax-incentives
          :estimation="estimation"
          :has-mpa-price="pricingType == 'mpa'"
          :has-dpa-price="pricingType == 'dpa'"
          :overflow="false"/>
      </div>

      <div v-if="estimationHasRailing">
        <div class="is-size-6 mb-2 has-text-weight-bold">
          Solar Railing Cost Breakdown (Total and per LF)
        </div>
        <tax-incentives
          :estimation="estimation"
          :has-mpa-price="pricingType == 'mpa'"
          :has-dpa-price="pricingType == 'dpa'"
          :overflow="false"
          rail-or-wall="rail"/>
      </div>

      <div class="is-size-6 mb-2 has-text-weight-bold">
        Summary of Possible Tax Incentives
      </div>
      <possible-tax-incentives
        :estimation="estimation"
        :has-mpa-price="pricingType == 'mpa'"
        :has-dpa-price="pricingType == 'dpa'"
        :overflow="false"/>

    </template>

  </div>
</template>

<script>
import PricingSummary from '@/components/proposalmaker/PricingSummary'
// import DetailedPricingRailing from '@/components/proposalmaker/DetailedPricingRailing'
// import DetailedPricingWall from '@/components/proposalmaker/DetailedPricingWall'
// import DetailedPricingCladding from '@/components/proposalmaker/DetailedPricingCladding'
import ValueSolarRailing from '@/components/proposalmaker/ValueSolarRailing'
import ValueSolarWall from '@/components/proposalmaker/ValueSolarWall'
import TaxIncentives from '@/components/proposalmaker/TaxIncentives'
import PossibleTaxIncentives from '@/components/proposalmaker/PossibleTaxIncentives'

export default {
  props: {
    estimation: {
      type: Object,
      required: true
    },
    pricingType: {
      type: String,
      default: 'mpa'
    },
    hasTaxIncentives: {
      type: Boolean,
      default: true
    }
  },
  components: { 
    PricingSummary, 
    // DetailedPricingRailing, 
    // DetailedPricingWall, 
    // DetailedPricingCladding,
    ValueSolarRailing,
    ValueSolarWall,
    TaxIncentives,
    PossibleTaxIncentives
  },
  computed: {
    estimationHasWall({ estimation }) {
      return estimation.estimation_summary.summary.filter(
          d => d.pricing_summary.includes('solar_wall')).length > 0 ||
          estimation.estimation_summary.irregular_price_by_material
            .filter(d => d.product_brand == 'Mitrex').length > 0;
    },
    estimationHasRailing({ estimation }) {
      return estimation.estimation_summary.summary.filter(
        d => d.pricing_summary.includes('railing')
      ).length > 0;
    },
    estimationHasCladding({ estimation }) {
      return estimation.estimation_summary.summary.filter(
        d => d.pricing_summary == 'cladding'
      ).length > 0 || estimation.estimation_summary.irregular_price_by_material
        .filter(d => d.product_brand == 'Cladify').length > 0;
    }
  }
}
</script>

<style scoped>
</style>